// GENERATED FILE. DO NOT EDIT BY HAND!!!
/* eslint-disable */
export const Activities = {
  activity: "activities:activity:?|fields:field:view",
  crop_assignment: "activities:crop_assignment:?|activities:activity:?",
  post_calibration: "activities:post_calibration:?|activities:activity:?",
  harvest_components: "activities:harvest_components:?|activities:activity:?",
  input_application_components: "activities:input_application_components:?|activities:activity:?",
  records: "activities:records:?|activities:activity:?",
  business_cycles: "activities:business_cycles:?|fields:field:view",
  production_cycles: "activities:production_cycles:?|fields:field:view",
  summaries: "activities:summaries:?",
  raster: "activities:raster:?|fields:field:view",
} as const;
export const Analysis = {
  layers: "analysis:layers:?",
  pivot: "analysis:pivot:?",
} as const;
export const Carbon = {
  enrollment_eligibility: "carbon:enrollment_eligibility:?|enrollments:field_enrollment:?",
  crop_rotation: "carbon:crop_rotation:?|carbon:enrollment_eligibility:?",
  field_boundary: "carbon:field_boundary:?|carbon:enrollment_eligibility:?",
  field_details: "carbon:field_details:?|carbon:enrollment_eligibility:?",
  practice_changes: "carbon:practice_changes:?|carbon:enrollment_eligibility:?",
} as const;
export const Documents = {
  report: "documents:report:?|fields:field:view",
  snapshot: "documents:snapshot:?|documents:report:?",
  soils: "documents:soils:?|documents:report:?",
} as const;
export const Enrollments = {
  enrollment: "enrollments:enrollment:?",
  field_enrollment: "enrollments:field_enrollment:?|fields:field:view",
} as const;
export const Fields = {
  field: "fields:field:?",
  farm: "fields:farm:?",
  field_group: "fields:field_group:?",
} as const;
export const Inputs = {
  custom: "inputs:custom:?",
} as const;
export const Integrations = {
  connection: "integrations:connection:?|fields:field:create",
  export: "integrations:export:?",
  upload: "integrations:upload:?",
  history: "integrations:history:?",
} as const;
export const Imagery = {
  sentinel2_enrollment: "imagery:sentinel2_enrollment:?",
} as const;
export const Layers = {
  layer: "layers:layer:?",
} as const;
export const Notes = {
  note: "notes:note:?|fields:field:view",
  reply: "notes:reply:?|notes:note:?",
  attachment: "notes:attachment:?|notes:note:?",
} as const;
export const Records = {
  machine_data: "records:machine_data:?|fields:field:create",
} as const;
export const Roles = {
  corteva_data_management: "roles:corteva_data_management:?",
  operation: "roles:operation:?",
  invite: "roles:invite:?",
} as const;
export const Landvisor = {
  farm_retreat: "landvisor:farm_retreat:?|fields:farm:?",
  pasture: "landvisor:pasture:?|fields:field:?",
  prediction: "landvisor:prediction:?|landvisor:pasture:view",
  product: "landvisor:product:?",
  treatment_plan: "landvisor:treatment_plan:?",
} as const;
export const Cropvisor = {
  fungicide_timing: "cropvisor:fungicide_timing:?|roles:operation:view",
} as const;

export const ModelNamespaces = {
  Activities,
  Analysis,
  Carbon,
  Documents,
  Enrollments,
  Fields,
  Inputs,
  Integrations,
  Imagery,
  Layers,
  Notes,
  Records,
  Roles,
  Landvisor,
  Cropvisor,
};

export type PermissionModel =
  | typeof ModelNamespaces["Activities"][keyof typeof Activities]
  | typeof ModelNamespaces["Analysis"][keyof typeof Analysis]
  | typeof ModelNamespaces["Carbon"][keyof typeof Carbon]
  | typeof ModelNamespaces["Documents"][keyof typeof Documents]
  | typeof ModelNamespaces["Enrollments"][keyof typeof Enrollments]
  | typeof ModelNamespaces["Fields"][keyof typeof Fields]
  | typeof ModelNamespaces["Inputs"][keyof typeof Inputs]
  | typeof ModelNamespaces["Integrations"][keyof typeof Integrations]
  | typeof ModelNamespaces["Imagery"][keyof typeof Imagery]
  | typeof ModelNamespaces["Layers"][keyof typeof Layers]
  | typeof ModelNamespaces["Notes"][keyof typeof Notes]
  | typeof ModelNamespaces["Records"][keyof typeof Records]
  | typeof ModelNamespaces["Roles"][keyof typeof Roles]
  | typeof ModelNamespaces["Landvisor"][keyof typeof Landvisor]
  | typeof ModelNamespaces["Cropvisor"][keyof typeof Cropvisor];
